module.exports = __webpack_public_path__ + "static/img/three-pigs.841e4ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/three-pigs.jpg
// module id = mXJy
// module chunks = 1